<template>
  <div id="app" :data-ifPC="String(ifPC)">
    <el-container v-if="ifPC">
      <Header />
      <keep-alive>
        <router-view />
      </keep-alive>
      <el-footer>
        <Footer />
      </el-footer>
    </el-container>
    <el-container v-else>
      <h5-header></h5-header>
      <keep-alive>
        <router-view />
      </keep-alive>
      <h5-footer></h5-footer>
    </el-container>
  </div>
</template>

<script>
class snapScroll {
  constructor({ container = null, prevBtn = null, nextBtn = null }) {
    this.container = container;
    this.prevBtn = prevBtn;
    this.nextBtn = nextBtn;
    this.lastChild = container ? container.lastElementChild : null;
  }

  btnClick(type) {
    let { container, prevBtn, nextBtn, lastChild } = this;
    if (!container || !lastChild || !prevBtn || !nextBtn) {
      return;
    }

    let { scrollWidth } = container;
    let containerClientWidth = container.clientWidth;
    let clientWidth = lastChild.clientWidth;
    let marginLeft =
      parseFloat(document.defaultView.getComputedStyle(lastChild).marginLeft) ||
      0;
    let left = container.scrollLeft;
    if (["prev", 0].includes(type)) {
      if (!prevBtn.dataset.disabled !== "true") {
        left = container.scrollLeft - clientWidth - marginLeft;
        prevBtn.dataset.disabled = left <= 1;
        nextBtn.dataset.disabled = false;
      } else {
        this.afterFn && this.afterFn();
      }
    } else if (["next", 1].includes(type)) {
      if (nextBtn.dataset.disabled !== "true") {
        left = container.scrollLeft + clientWidth + marginLeft;
        prevBtn.dataset.disabled = false;
        nextBtn.dataset.disabled =
          left + containerClientWidth + 1 >= scrollWidth;
      } else {
        this.afterFn && this.afterFn();
      }
    }
    container.scrollLeft = left;
  }
}

import Header from "./components/Header";
import Footer from "./components/Footer";
import H5Header from "./page/h5/home-header";
import H5Footer from "./page/h5/home-footer";
export default {
  name: "App",
  data() {
    return {
      ifPC: true
    }

  },
  components: {
    Header,
    Footer,
    H5Header,
    H5Footer
  },
  provide: {
    snapScroll
  },
  mounted: function() {
    this.browserRedirect();
  },
  methods: {
    browserRedirect() {
        var sUserAgent = navigator.userAgent.toLowerCase();
        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
        var bIsAndroid = sUserAgent.match(/android/i) == "android";
        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
        if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
            this.ifPC = false;
        } else {
            this.ifPC = true;
        }
    }
  }
};
</script>

<style>
@import '../node_modules/element-ui/lib/theme-chalk/index.css';
@import '../node_modules/element-ui/lib/theme-chalk/display.css';
@import '../src/assets/styles/reset.css';
@import '../src/assets/styles/border.css';
@import '../src/assets/styles/iconfont.css';

#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.el-header,
.el-main,
.el-footer {
  margin: 0;
  padding: 0;
}

@media (max-width: 992px) {
  .el-main {
    /*margin-top: 20px;*/
  }
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/App.vue